module.exports = __webpack_public_path__ + "img/user.a3d9b658.png";